// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"840cbc34","498":"7382652b","703":"55630bf4"}[chunkId] + ".chunk.js";
};